// Generated from the TokenTax Icons Figma Final page. Do not edit.
import * as React from 'react';
import type { IconProps } from './types';
import { Ref, forwardRef } from 'react';
const Bolt = ({ size, ...props }: IconProps, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size ?? 18}
    height={size ?? 18}
    fill="none"
    viewBox="0 0 18 18"
    ref={ref}
    {...props}
  >
    <path stroke="currentColor" d="m10.533 8.32-.26.68H13l-7.41 5.556L7.468 9.68l.26-.68H5l7.408-5.557z" />
  </svg>
);
const ForwardRef = forwardRef(Bolt);
export default ForwardRef;
